<template>
  <div :class="[$style.loadingWrap, $style[fileType]]">
    <div :class="$style.loading"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Loading',
  computed: mapState(['fileType'])
}
</script>

<style lang="scss" module>
$width: 40px;
$height: 40px;

.loadingWrap {
  width: $width;
  height: $height;
}
.audio {
  background: url(./assets/audio_icon.svg) no-repeat 50%;
  background-size: 24px;
}
.video {
  background: url(./assets/video_icon.svg) no-repeat 50%;
  background-size: 24px;
}
.loading {
  width: $width;
  height: $height;
  overflow: hidden;
  position: relative;
  transform-origin: $width / 2 $height / 2;
  animation: rotate 1.2s infinite linear;

  &::before {
    content: '';
    border: 2px solid #4991f2;
    border-left: 2px solid #e2e6ed;
    width: $width;
    height: $height;
    position: absolute;
    left: 0;
    top: 0;
    box-sizing: border-box;
    border-radius: 50%;
  }
}
:global {
  @keyframes rotate {
    0% {
      transform: rotate(0deg)
    }
    100% {
      transform: rotate(360deg)
    }
  }
}
</style>
